// import { DashboardCustomize, DashboardSharp } from '@mui/icons-material'
// import React, { useEffect } from 'react'
// import DashboardCard from '../../../Components/DashboardCard/DashboardCard'
// import { use } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice'
// import BellCurveChart from './BellCurve'
// import { Box, Button, Container, Grid } from '@mui/material'
// import PerformanceReport from './PerformanceReport'
// import LatestEvaluations from './LatestEvaluations'
// import actions from '../../../ReduxStore/actions'

// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import PeopleIcon from '@mui/icons-material/People';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import { FaUsers } from 'react-icons/fa6'
// import { FaCheckCircle } from 'react-icons/fa'
// import { HiUserGroup } from 'react-icons/hi2'
// import BellCurveMainPage from '../Reports/BellCurveMainPage'
// import { Formik, Form } from 'formik'
// import CustomDropdownMui from '../../../Components/CustomDropDown/CustomDropdown'

// const Dashboard = () => {
//     const dispatch = useDispatch()

//     console.log("iitswork")
//     useEffect(() => {
//         dispatch(setHeaderName("Dashboard"));
//         dispatch(setSubHeaderName(""));
//     }, [dispatch]);
//     const { getAdminDashboard } = useSelector((state) => state?.getAdminDashboard);

//     const { getAllAppraisalYears } = useSelector((state) => state?.getAllAppraisalYears);
//     console.log(getAllAppraisalYears, "getAllAppraisalYears")

//     useEffect(() => {
//         const fetchData = async () => {

//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: "getAllAppraisalYears"
//             };
//             const responseData = dispatch(actions.GETALLAPPRAISALYEAR(data1));
//             console.log(responseData, "responseData")

//         }
//         fetchData()

//     }, [])

//     const yearOptions = getAllAppraisalYears?.data?.map((data, index) => ({

//         // id: data?.internship_id,
//         value: data?.appraisal_year_id,
//         label: data?.appraisal_year
//     }));
//     console.log(yearOptions, "yearOptions")

//     useEffect(() => {
//         const fetchData = async () => {

//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: "getAdminDashboard"
//             };
//             const responseData = dispatch(actions.GETADMINDASHBOARD(data1));
//             console.log(responseData, "responseData")

//         }
//         fetchData()

//     }, [])

//     const handleaGetDataYearById = () => {

//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: "getAdminDashboardByYear"
//             };
//             const responseData = dispatch(actions.GETADMINDASHBOARDBYYEAR(data1));
//             console.log(responseData, "responseData")

//         }

//     const stats = [
//         {
//             icon: <FaUsers style={{ color: 'white', fontSize: "25px" }} />,
//             iconColor: '#212121',
//             title: 'Total Employee',
//             total: getAdminDashboard?.data?.total_employee_count,
//         },
//         {
//             icon: <PeopleIcon sx={{ color: '#fff' }} />,
//             iconColor: '#e91e63',
//             title: 'Employee Evaluation',
//             total: getAdminDashboard?.data?.employee_appraisal_total,
//             pending: getAdminDashboard?.data?.employee_appraisal_pending,
//             completed: getAdminDashboard?.data?.employee_appraisal_completed
//         },
//         {
//             icon: <GroupAddIcon sx={{ color: '#fff' }} />,
//             iconColor: '#4caf50',
//             title: 'Manager Evaluation',
//             total: getAdminDashboard?.data?.manager_employee_appraisal_total,
//             pending: getAdminDashboard?.data?.manager_employee_appraisal_pending,
//             completed: getAdminDashboard?.data?.manager_employee_appraisal_completed

//         },
//         {
//             icon: <HiUserGroup style={{ color: '#fff', fontSize: "25px" }} />,
//             iconColor: '#2196f3',
//             title: 'Reviewer Evaluation',
//             total: getAdminDashboard?.data?.reviewer_employee_appraisal_total,
//             pending: getAdminDashboard?.data?.reviewer_employee_appraisal_pending,
//             completed: getAdminDashboard?.data?.reviewer_employee_appraisal_completed

//         },
//         {
//             icon: <FaCheckCircle style={{ color: 'white', fontSize: "25px" }} />,
//             iconColor: '#2196f3',
//             title: 'PMS Closed',
//             total: getAdminDashboard?.data?.total_appraisal_closed,
//         },
//     ];

//     return (
//         <Grid container spacing={2}>

//             <Grid size={{ xs: 12 }}>
//                 <Formik
//                     initialValues=
//                     {{ filterByYear: "" }}

//                     // validationSchema={validationSchema}
//                     onSubmit={(values) => {

//                         handleaGetDataYearById(values?.filterByYear)
//                     }}
//                 >
//                     {({ isSubmitting, values, setFieldValue, resetForm, errors, touched, handleChange, handleBlur }) => (
//                         <Form>

//                             <Grid container spacing={2}>

//                                 <>
//                                     <Grid item size={{ sm: 5, xs: 12 }}>
//                                         <CustomDropdownMui
//                                             name="filterByYear"
//                                             label="Filter by Year"
//                                             custPlaceholder="--Select--"
//                                             // disabled
//                                             options={yearOptions}
//                                         />
//                                     </Grid>

//                                 </>

//                                 <Grid item size={{ sm: 3, xs: 12 }}>

//                                     <Box sx={{
//                                         mt: { xs: 1, sm: 0 },
//                                         //  display: "flex", alignItems: "center", justifyContent: "center"
//                                     }}>
//                                         <Button
//                                             // onClick={() => {
//                                             //   handleAddNavigate()
//                                             // }}
//                                             type="submit"
//                                             variant="contained"
//                                             sx={{
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 padding: { xs: "0px 20px", md: "0px 20px" },

//                                                 boxShadow: "none",
//                                                 minHeight: "40px",
//                                                 // borderRadius: "23px",
//                                                 background: "var(--main-color) 0% 0% no-repeat padding-box",
//                                                 "&:hover": {
//                                                     backgroundColor: "var(--main-color)",
//                                                 },
//                                             }}
//                                         >
//                                             Apply Filter
//                                         </Button>
//                                     </Box>
//                                 </Grid>
//                             </Grid>

//                         </Form>
//                     )}
//                 </Formik>
//             </Grid>

//             <Grid size={{ xs: 12 }}>
//                 <DashboardCard stats={stats} />
//             </Grid>

//             <Grid size={{ xs: 12 }}>
//                 <BellCurveMainPage />
//             </Grid>
//             {/* <Container>
//                 <BellCurveChart />
//             </Container> */}
//             {/* <Grid size={{ xs: 12 }}>

//                 <Box sx={{ mt: 2 }}>
//                     <PerformanceReport />
//                 </Box>
//             </Grid> */}
//             {/* <Grid size={{ xs: 12 }}>

//                 <Box sx={{ mt: 2 }}>
//                     <LatestEvaluations />
//                 </Box>
//             </Grid> */}

//         </Grid>
//     )
// }

// export default Dashboard
import React, { useEffect, useState } from "react";
import { Grid, Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setHeaderName,
  setSubHeaderName,
} from "../../../ReduxStore/Slices/headerSlice";
import actions from "../../../ReduxStore/actions";

import DashboardCard from "../../../Components/DashboardCard/DashboardCard";
import BellCurveMainPage from "../Reports/BellCurveMainPage";
import { Formik, Form } from "formik";
import CustomDropdownMui from "../../../Components/CustomDropDown/CustomDropdown";

import PeopleIcon from "@mui/icons-material/People";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { FaUsers, FaCheckCircle } from "react-icons/fa";
import { HiUserGroup } from "react-icons/hi2";
import { setInitialStateOfgetAdminDashboard } from "../../../ReduxStore/Slices/Dashboard/getAdminDashboard";
import { setInitialStateOfgetAdminDashboardByYear } from "../../../ReduxStore/Slices/Dashboard/getAdminDashboardByYear";
import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { getAllAppraisalYears } = useSelector(
    (state) => state?.getAllAppraisalYears
  );
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    dispatch(setHeaderName("Dashboard"));
    dispatch(setSubHeaderName(""));
  }, [dispatch]);

  useEffect(() => {
    const fetchAppraisalYears = async () => {
      const data = {
        data: {},
        method: "get",
        apiName: "getAllAppraisalYears",
      };
      await dispatch(actions.GETALLAPPRAISALYEAR(data));
    };
    fetchAppraisalYears();
  }, [dispatch]);

  useEffect(() => {
    setLoading(true);
    const fetchDashboardData = async () => {
      const data = {
        data: {},
        method: "get",
        apiName: "getAdminDashboard",
      };
      const response = await dispatch(actions.GETADMINDASHBOARD(data));
      setDashboardData(response?.payload?.data || null);
      if (response?.payload?.message === "All employees dashboard fetched successfully") {
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, [dispatch]);

  const handleGetDataYearById = async (yearId) => {
    setLoading(true);
    const data = {
      data: { appraisal_year_id: yearId },
      method: "post",
      apiName: "getAdminDashboardByYear",
    };
    const response = await dispatch(actions.GETADMINDASHBOARDBYYEAR(data));
    setDashboardData(response?.payload?.data || null);
    if (response?.payload?.message === "All employees dashboard by year fetched successfully") {
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const yearOptions =
    getAllAppraisalYears?.data?.map((item) => ({
      value: item?.appraisal_year_id,
      label: item?.appraisal_year,
    })) || [];

  const stats = [
    {
      icon: <FaUsers style={{ color: "white", fontSize: "25px" }} />,
      iconColor: "#212121",
      title: "Total Appraisal",
      total: dashboardData?.total_employee_count,
    },
    {
      icon: <PeopleIcon sx={{ color: "#fff" }} />,
      iconColor: "#e91e63",
      title: "Employee Evaluation",
      total: dashboardData?.employee_appraisal_total,
      pending: dashboardData?.employee_appraisal_pending,
      completed: dashboardData?.employee_appraisal_completed,
    },
    {
      icon: <GroupAddIcon sx={{ color: "#fff" }} />,
      iconColor: "#4caf50",
      title: "Manager Evaluation",
      total: dashboardData?.manager_employee_appraisal_total,
      pending: dashboardData?.manager_employee_appraisal_pending,
      completed: dashboardData?.manager_employee_appraisal_completed,
    },
    {
      icon: <HiUserGroup style={{ color: "#fff", fontSize: "25px" }} />,
      iconColor: "#2196f3",
      title: "Reviewer Evaluation",
      total: dashboardData?.reviewer_employee_appraisal_total,
      pending: dashboardData?.reviewer_employee_appraisal_pending,
      completed: dashboardData?.reviewer_employee_appraisal_completed,
    },
    {
      icon: <FaCheckCircle style={{ color: "white", fontSize: "25px" }} />,
      iconColor: "#2196f3",
      title: "PMS Closed",
      total: dashboardData?.total_appraisal_closed,
    },
    {
      icon: <FaUsers style={{ color: "white", fontSize: "25px" }} />,
      iconColor: "#212121",
      title: "Total Employees",
      total: dashboardData?.total_employee,

      active: dashboardData?.active_users,
      inActive: dashboardData?.inactive_users,
    },
  ];
  const handleClearFilter = async (resetForm) => {
    setLoading(true);
    resetForm();
    dispatch(setInitialStateOfgetAdminDashboardByYear());
    const data = {
      data: {},
      method: "get",
      apiName: "getAdminDashboard",
    };
    const response = await dispatch(actions.GETADMINDASHBOARD(data));
    setDashboardData(response?.payload?.data || null);
    if (response?.payload?.message === "All employees dashboard fetched successfully") {
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={2}>
      {loading && <FullPageLoader />}

      <Grid item size={{ xs: 12 }}>
        <Formik
          initialValues={{ filterByYear: "" }}
          onSubmit={(values) => {
            handleGetDataYearById(values.filterByYear);
          }}
        >
          {({ values, setFieldValue, resetForm }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item size={{ xs: 12, sm: 6 }}>
                  <CustomDropdownMui
                    name="filterByYear"
                    label="Filter by Year"
                    custPlaceholder="--Select--"
                    options={yearOptions}
                    isDashboard={true}
                  />
                </Grid>

                <Grid
                  item
                  size={{ xs: 12, sm: 6 }}
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "end",
                  }}
                >
                  <Box
                    sx={{
                      mt: { xs: 1, sm: 0 },
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {values?.filterByYear && (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={() => {
                          handleClearFilter(resetForm);
                        }}
                        sx={{
                          background: "#e3e2e2",
                          textTransform: "none",
                          color: "black",
                          mr: 2,
                          boxShadow: "none",
                        }}
                      >
                        Clear Filter
                      </Button>
                    )}
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={!values?.filterByYear}
                      sx={{
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        padding: { xs: "0px 20px", md: "0px 20px" },
                        boxShadow: "none",
                        minHeight: "40px",
                        background: "var(--main-color)",
                        "&:hover": {
                          backgroundColor: "var(--main-color)",
                        },
                      }}
                    >
                      Apply Filter
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>

      <Grid item size={{ xs: 12 }} sx={{ mt: 2 }}>
        <DashboardCard stats={stats} />
      </Grid>

      <Grid item size={{ xs: 12 }}>
        <BellCurveMainPage />
      </Grid>
    </Grid>
  );
};

export default Dashboard;
